import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b19b4000"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-login c-secondary" }
const _hoisted_2 = { class: "input" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "submit" }

import articles from '@/store/articles/home';
import devices from '@/store/device';
import i18, { State as I18State } from '@/store/i18';
import { computed, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'close'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    options: {
        resolve: Function,
        reject: Function,
        id: number,
    },
}

const store = useStore()

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].article)


const state = reactive({
    visible: false,
    content: '',
})


onMounted(async () => {
})

async function onSubmit() {
    if (!state.content) {
        devices.toast(store, lang.value.comment_error)
        return
    }
    try {
        await articles.postComment(store, props.options.id, state.content)
        devices.toast(store, lang.value.comment_success)
        emits('close')
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}

function onCancel() {
    props.options.reject(new Event('cancel comment'))
    emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: onCancel
    }),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).content) = $event)),
        placeholder: _unref(lang).comment_placeholder
      }, null, 8, _hoisted_3), [
        [_vModelText, _unref(state).content]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", { onClick: onSubmit }, _toDisplayString(_unref(lang).comment_submit), 1)
    ])
  ]))
}
}

})